import moment from "moment";

import "moment/locale/pl";
import "moment/locale/sk";
import "moment/locale/en-gb";
import "moment/locale/cs";
import "moment/locale/de";
import "moment/locale/ru";
import "moment/locale/uk";
import "moment/locale/es";

export const setLocale = (lang: string) => {
    switch (lang) {
        case "en":
            moment.locale("en");
            return "en";
        case "sk":
            moment.locale("sk");
            return "sk";
        case "cz":
            moment.locale("cs");
            return "cs";
        case "de":
            moment.locale("de");
            return "de";
        case "ru":
            moment.locale("ru");
            return "ru";
        case "ua":
            moment.locale("uk");
            return "uk";
        case "es":
            moment.locale("es");
            return "es";
        default:
            moment.locale("pl");
            return "pl";
    }
  }